<template>
  <div>
    <vs-card>
     <!-- <pre>{{localValue}}</pre>  -->
      <div slot="header" v-if="!value.editingtrue">
        <vs-row>
          <vs-col
            vs-offset="2"
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="8"
          >
            <h5>Course Builder</h5>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col
            vs-offset="2"
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="8"
          >
            <p>(Create new course here)</p>
          </vs-col>
        </vs-row>
      </div>
      <div>
        <vs-row>
          <vs-col vs-type="flex" vs-justify="center" vs-align="center">
            <vs-input
              class="w-full mt-5"
              placeholder="Title"
              v-model="localValue.name"
              v-validate="'required'"
              name="Course Title"
              data-vv-name="Course Title"
              @keypress="preventKeypress"
            />
          </vs-col>
          <span
            v-show="errors.has('CourseBuilder.Course Title')"
            class="text-danger block"
            >{{ errors.first("CourseBuilder.Course Title") }}</span
          >
        </vs-row>
        <vs-row>
          <vs-col vs-type="flex" vs-justify="center" vs-align="center">
            <vs-textarea
              class="w-full mt-5"
              label="Description"
              v-model="localValue.description"
              name="course_description"
              data-vv-name="course_description"
            />
          </vs-col>

          <span
            v-show="errors.has('CourseBuilder.course_description')"
            class="text-danger block"
            >{{ errors.first("CourseBuilder.course_description") }}</span
          >
        </vs-row>

        <!-- <pre>{{localValue.course_image_info.file.file_path}}</pre> -->
        <!-- {{localValue.course_image_info}} -->
        <!-- <vs-row v-if="value.editingtrue">
          <vs-col v-if="localValue.course_image_info">
            <img :src="localValue.course_image_info.file.file_path" />
          </vs-col>
        </vs-row> -->

       <!-- <pre> {{localValue.course_image_info}}</pre> -->
        <!-- {{filesInfo}} -->
         <vs-row v-if="localValue.course_image_info && value.editingtrue">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <file-showing :singleFileInfo="localValue.course_image_info.file"
          :deleteOption="false"
          ></file-showing>
        </vs-col>
      </vs-row>

        <vs-row>
          <vs-col>
            <file-upload
              section_type="courseHeader"
              @getFileIdHeader="getIdFile"
              :multiplefile="false"
              :file_repository_id="file_repository_id"
              :onlyImage="true"
            ></file-upload>
          </vs-col>
        </vs-row>
      </div>
    </vs-card>
  </div>
</template>


<script>
import FileUpload from './FileUploadComponent.vue/FileUpload.vue'
import FileShowing from './FileUploadComponent.vue/FileShowing.vue'
import { handleKeypress } from '@/mixins/handleKeypress'

export default {
  inject: {
    $validator: '$validator'
  },

  components: {
    FileUpload,
    FileShowing
  },
  mixins: [handleKeypress],
  props: {
    value: {
      required: true,
      type: Object,
      default: () => {}
    },
    file_repository_id: {
      required: false,
      type: Number,
      default: 0
    }
  },
  computed: {
    localValue: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    getIdFile (file_id) {
      
      this.localValue.course_image = file_id
    }
  }
}
</script>

<style scoped>

</style>